import { useModal } from "@uiview/views/AModal/useModal";
import { createContext } from "react";

export type AModalContextType = {
  showModal: ReturnType<typeof useModal>;
};

export const AModalContext = createContext<AModalContextType | undefined>(undefined);
